import templateUrl from './detectorEventTable.tpl.html';

export const detectorEventTable = [
    'eventModal',
    'alertingService',
    'alertTypeService',
    'detectorPriorityService',
    function (eventModal, alertingService, alertTypeService, detectorPriorityService) {
        return {
            scope: {
                detectorEvents: '=',
                pinTime: '=',
                createNewEvent: '=',
                hasEventsTab: '=',
            },
            restrict: 'E',
            templateUrl,
            link: function (scope) {
                scope.showEventDetails = function (event) {
                    if (
                        alertingService.shouldOpenAlertDetailsPage() &&
                        event?.metadata?.sf_eventCategory === 'ALERT' &&
                        event?.id
                    ) {
                        alertingService
                            .getCurrentPageNavigationContext()
                            .then((navigationContext) => {
                                alertingService.navigateToAlertDetails(event.id, navigationContext);
                            });
                        return;
                    }

                    eventModal(event);
                };

                scope.getAlertClass = function (severity) {
                    return detectorPriorityService.getAlertClassBySeverity(severity);
                };

                scope.getDisplayText = function (state) {
                    return alertTypeService.getDisplayFor(state);
                };

                scope.isClearingEvent = function (state) {
                    return alertTypeService.isClearingEvent(state);
                };
            },
        };
    },
];
